// 「吃瓜百科」页面数据类型与工具

export interface Term {
  id: string;
  title: string;
  category: string;
  tag: string;
  hot: number;
  summary: string;
  content: string[];
  origin: string;
  usage: string;
  tips: string;
  related: string[];
}

export interface CategoryOption {
  key: string;
  label: string;
}

export interface HotItem {
  rank: number;
  term: string;
  note: string;
  hot: number;
  change: string;
}

export interface FeaturedRead {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  body: string[];
  minutes: number;
  image: string;
}

export interface QuickFact {
  key: string;
  category: string;
  title: string;
  text: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export function findTermByTitle(list: Term[], title: string): Term | undefined {
  return list.find((t) => t.title === title);
}